"use strict";

var _interopRequireDefault = require("D:/vescort-platform-pc-website/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getGoodsTypeData = exports.getDictsData = exports.getDictData = exports.getCarTypeData = void 0;
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("D:/vescort-platform-pc-website/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _api = require("../api/api");
var dictsCodeStr = 'MERCHANT_POST_TYPE,MERCHANT_JOB_SALARY,MERCHANT_WELFARE,' + 'MERCHANT_WORK_TIME,MERCHANT_JOB_STATUS,MERCHANT_CERTIFICATE,MERCHANT_CAR_TYPE,' + 'MERCHANT_PURCHASE_TIME,MERCHANT_PRICE,MERCHANT_MILEAGE'; // 需查询的数据字典code

// 获取车辆类型
var getCarTypeData = exports.getCarTypeData = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    var result, _yield$apiPostData, data;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          result = null;
          _context.next = 3;
          return (0, _api.apiPostData)('/vescort/basedata/apiaction/getvehicletype');
        case 3:
          _yield$apiPostData = _context.sent;
          data = _yield$apiPostData.data;
          if (data.proCode == '200') {
            result = data.proData;
          }
          return _context.abrupt("return", result);
        case 7:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function getCarTypeData() {
    return _ref.apply(this, arguments);
  };
}();

// 获取货物类型
var getGoodsTypeData = exports.getGoodsTypeData = /*#__PURE__*/function () {
  var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
    var result, _yield$apiPostData2, data;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          result = null;
          _context2.next = 3;
          return (0, _api.apiPostData)('/vescort/basedata/apiaction/findpcgoodstype');
        case 3:
          _yield$apiPostData2 = _context2.sent;
          data = _yield$apiPostData2.data;
          if (data.proCode == '200') {
            result = data.proData;
          }
          return _context2.abrupt("return", result);
        case 7:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function getGoodsTypeData() {
    return _ref2.apply(this, arguments);
  };
}();

// 获取数据字典
// 一类一项: CD_GOODS_TYPE, I类包装: CD_PACKAGE_TYPE, 立方米: CD_GOODS_UNIT
// 月薪：MERCHANT_JOB_SALARY，福利待遇：MERCHANT_WELFARE，工作年限：MERCHANT_WORK_TIME，求职状态：MERCHANT_JOB_STATUS
// 行业资质证书：MERCHANT_CERTIFICATE，车辆类型：MERCHANT_CAR_TYPE，购买时长/车龄：MERCHANT_PURCHASE_TIME，车辆价格：MERCHANT_PRICE，
// 行驶里程：MERCHANT_MILEAGE，岗位：MERCHANT_POST_TYPE
var getDictData = exports.getDictData = /*#__PURE__*/function () {
  var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(dicttypekey) {
    var result, jsonParam, _yield$apiPostData3, data;
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          result = null;
          jsonParam = {
            "dicttypekey": dicttypekey
          };
          _context3.next = 4;
          return (0, _api.apiPostData)('/vescort/sys/dictAction/finddictdata', jsonParam);
        case 4:
          _yield$apiPostData3 = _context3.sent;
          data = _yield$apiPostData3.data;
          if (data.code == '200') {
            // console.log("getDictData:",data.datalist)
            result = data.datalist;
          }
          return _context3.abrupt("return", result);
        case 8:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return function getDictData(_x) {
    return _ref3.apply(this, arguments);
  };
}();

// 一次性查询多个数据字典
var getDictsData = exports.getDictsData = /*#__PURE__*/function () {
  var _ref4 = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
    var dicttypekey,
      result,
      jsonParam,
      _yield$apiPostData4,
      data,
      _args4 = arguments;
    return regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          dicttypekey = _args4.length > 0 && _args4[0] !== undefined ? _args4[0] : dictsCodeStr;
          // dicttypekey 逗号隔开
          result = null;
          jsonParam = {
            "dicttypekey": dicttypekey
          };
          _context4.next = 5;
          return (0, _api.apiPostData)('/vescort/sys/dictAction/finddictsdata', jsonParam);
        case 5:
          _yield$apiPostData4 = _context4.sent;
          data = _yield$apiPostData4.data;
          if (data.code == '200') {
            // console.log("getDictsData:",data.data)
            result = data.data;
          }
          return _context4.abrupt("return", result);
        case 9:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return function getDictsData() {
    return _ref4.apply(this, arguments);
  };
}();